import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFirebaseComponent } from './simple-icons-firebase.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFirebaseComponent ],
    exports:      [ SimpleIconsFirebaseComponent ],
    bootstrap:    []
})
export class SimpleIconsFirebaseModule {}
